<div class="flex-wrapper panel-block-wrapper">
    <div class="flex-item flex-item-cols-{{block.content.length}}" *ngFor="let card of block.content">
        <div class="card">
            <img *ngIf="block.data.image" class="card-img-top" [src]="card.data.image.value" alt="Card image cap">
            <div class="card-body">
                <h5 *ngIf="card.data.title" class="card-title">{{card.data.title}}</h5>
                <p *ngIf="card.data.text" class="card-text">{{card.data.text}}</p>
                <a *ngIf="card.data.url" [href]="card.data.url">{{card.data.linkText}}</a>
            </div>
        </div>
    </div>
</div>
